import { Layouts } from 'react-grid-layout';

export const layoutConfig: Layouts | undefined = {
    lg: [
        {
            h: 42,
            static: true,
            w: 24,
            x: 0,
            y: 1,
            i: 'c2',
        },
        {
            h: 1,
            static: true,
            w: 24,
            x: 0,
            y: 0,
            i: 'c1',
        },
    ],
    md: [
        {
            h: 32,
            static: true,
            w: 24,
            x: 0,
            y: 1,
            i: 'c2',
        },
        {
            h: 1,
            static: true,
            w: 24,
            x: 0,
            y: 0,
            i: 'c1',
        },
    ],
    xs: [
        {
            h: 40,
            static: true,
            w: 24,
            x: 0,
            y: 2,
            i: 'c2',
        },
        {
            h: 2,
            static: true,
            w: 24,
            x: 0,
            y: 0,
            i: 'c1',
        },
    ],
};
export const pageConfig: PageConfig = {
    pageProps: {},
    components: [
        {
            key: 'c1',
            name: 'page-header',
            props: {
                header: {
                    title: '',
                },
                rhsComponents: [
                    {
                        name: 'page-switcher',
                        props: {
                            text: 'tableau-to-ppt',
                            path: '/reports/tableau-to-ppt',
                            ga_event_name: 'Tableau to PPT > View Reports',
                        },
                    },
                ],
            },
        },
        {
            name: 'canopy-table',
            key: 'c2',
            apiDetails: {
                endpoint: `reports/tableau/files?`,
                endpointParams: {
                    per_page: '*,per_page',
                    page: '*,page',
                    sort_column: 'sortColumn',
                    sort_direction: 'sortDirection',
                },
            },
            props: {
                headerText: 'reports',
                requiredQueryFields: [],
                dataKey: 'reports',
                title: '',
                showColumnSelectorOn: ['mobile'],
                showDownloadOn: [],
                showFilterOn: [],
                showSearchOn: [],
                actionBar: false,
                columns: [
                    {
                        key: 'fileName',
                        width: 160,
                        type: 'text',
                        headerText: 'filename',
                        selectedByDefaultOn: ['desktop', 'mobile', 'tablet'],
                        canSort: true,
                    },
                    {
                        key: 'createdAt',
                        type: 'date',
                        colSpan: '1',
                        headerText: 'table-headers.created-at',
                        selectedByDefaultOn: ['desktop', 'tablet', 'mobile'],
                        width: 100,
                        canSort: true,
                        dateFormat: '',
                        toDateFormat: 'lll',
                    },
                    {
                        key: 'downloadLink',
                        type: 'reportActions',
                        otherKeys: ['fileName'],
                        headerText: 'action',
                        selectedByDefaultOn: ['desktop', 'tablet'],
                    },
                ],
                per_page: 25,
                ga_event_name: 'View Reports',
            },
        },
    ],
};
